// shippingNote/AddShippingNoteInvoice.jsx
import React, { useEffect } from "react";
import Select from "react-select";
import validator from "validator";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Table,
  Badge,
} from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { addSaleInvoice } from "../../../../../Redux/saleInvoiceSlice";
import { useInvoiceData, notify } from "../hooks/useInvoiceData";

function AddShippingNoteInvoice() {
  const {
    date,
    setDate,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    invoiceItems,
    setInvoiceItems,
    invoiceNumber,
    setInvoiceNumber,
    products,
    drivers,
    cities,
    selectedCities,
    setSelectedCities,
    driver,
    setDriver,
    totalHT,
    setTotalHT,
    totalTTC,
    setTotalTTC,
    totalVAT,
    setTotalVAT,
    status,
    setStatus,

    id,
    dispatch,
    navigate,
    calculateTotals,
  } = useInvoiceData("SHIPPING_NOTE_INVOICE", false);

  useEffect(() => {
    calculateTotals();
  }, [calculateTotals]);

  const handleItemChange = (index, field, value) => {
    const newItems = invoiceItems.map((item, i) => {
      if (i === index) {
        let updatedItem = { ...item, [field]: value };

        if (field === "productId") {
          const selectedProduct = products.find((p) => p.id === value);
          if (selectedProduct) {
            updatedItem.price =
              selectedProduct.salePrice || selectedProduct.price || 0;
            updatedItem.vatRate = selectedProduct.vat || 0; // FIXED: Changed from vatRate to vat
          }
        }
        console.log(updatedItem);

        const itemHT = (updatedItem.price || 0) * (updatedItem.quantity || 0);
        const itemVAT = itemHT * ((updatedItem.vatRate || 0) / 100);

        updatedItem.totalHT = itemHT;
        updatedItem.vatAmount = itemVAT;
        updatedItem.totalTTC = itemHT + itemVAT;

        return updatedItem;
      }
      return item;
    });

    setInvoiceItems(newItems);
  };

  const handleAddItem = () => {
    setInvoiceItems([
      ...invoiceItems,
      {
        productId: "",
        quantity: 1,
        price: 0,
        vatRate: 0,
        vatAmount: 0,
        totalHT: 0,
        totalTTC: 0,
      },
    ]);
  };

  const handleRemoveItem = (index) => {
    const newItems = invoiceItems.filter((_, i) => i !== index);
    setInvoiceItems(newItems);
  };

  const submitForm = async () => {
    if (validator.isEmpty(invoiceNumber)) {
      notify(2, "Numéro de facture est obligatoire");
      return;
    }

    if (!driver) {
      notify(2, "Chauffeur est obligatoire");
      return;
    }

    if (selectedCities.length === 0) {
      notify(2, "Au moins une ville doit être sélectionnée");
      return;
    }

    if (!startDate) {
      notify(2, "Date de début est obligatoire");
      return;
    }

    if (!endDate) {
      notify(2, "Date de fin est obligatoire");
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      notify(2, "La date de début doit être antérieure à la date de fin");
      return;
    }

    if (invoiceItems.length === 0) {
      notify(2, "Au moins un article est obligatoire");
      return;
    }

    for (let i = 0; i < invoiceItems.length; i++) {
      if (!invoiceItems[i].productId) {
        notify(2, `L'article ${i + 1} doit avoir un produit sélectionné`);
        return;
      }
    }

    const items = invoiceItems.map((item) => ({
      productId: item.productId,
      quantity: item.quantity,
      price: item.price,
      vatRate: item.vatRate,
      vatAmount: item.vatAmount,
    }));

    try {
      const invoiceData = {
        invoiceNumber,
        date,
        startDate,
        endDate,
        type: "SHIPPING_NOTE_INVOICE",
        status,
        items,
        totalHT,
        totalTTC,
        driverId: driver.value,
        cityIds: selectedCities.map((city) => city.value),
      };

      await dispatch(addSaleInvoice(invoiceData));
      notify(1, "Facture bon sortie ajoutée avec succès");

      setTimeout(
        () => navigate.push("/sale-invoices/list/SHIPPING_NOTE_INVOICE"),
        1500,
      );
    } catch (error) {
      notify(2, "Erreur lors de l'enregistrement");
    }
  };

  const statusOptions = [
    { value: "DRAFT", label: "Brouillon" },
    { value: "VALIDATED", label: "Validée" },
    { value: "PAID", label: "Payée" },
    { value: "CANCELLED", label: "Annulée" },
  ];
  const getSelectedProductOption = (productId) => {
    if (!productId) return null;
    const product = products.find((p) => p.id === productId);
    return product
      ? {
          value: product.id,
          label: product.name,
          price: product.salePrice || product.price || 0,
          vatRate: product.vat,
        }
      : null;
  };
  return (
    <Container fluid>
      <ToastContainer />
      <Row>
        <Col md="12">
          <Button
            className="btn-wd btn-outline mr-1 float-left"
            variant="info"
            onClick={() =>
              navigate.push("/sale-invoices/list/SHIPPING_NOTE_INVOICE")
            }
          >
            <span className="btn-label">
              <i className="fas fa-list"></i>
            </span>
            Retour à la liste
          </Button>
        </Col>
      </Row>

      <Form className="form">
        <Card>
          <Card.Header>
            <Card.Title as="h4">Ajouter facture bon sortie</Card.Title>
          </Card.Header>

          <Card.Body>
            <Row>
              <Col md="4">
                <Form.Group>
                  <label>Numéro de facture* </label>
                  <Form.Control
                    value={invoiceNumber}
                    placeholder="Ex: BS-2023-001"
                    onChange={(e) => setInvoiceNumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group>
                  <label>Type de facture* </label>
                  <Form.Control value="Facture bon sortie" readOnly />
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group>
                  <label>Statut </label>
                  <Select
                    value={statusOptions.find((opt) => opt.value === status)}
                    options={statusOptions}
                    onChange={(e) => setStatus(e.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <Form.Group>
                  <label>Date* </label>
                  <Form.Control
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md="8">
                <Form.Group>
                  <label>Chauffeur* </label>
                  <Select
                    placeholder="Sélectionner un chauffeur"
                    value={driver}
                    options={drivers.map((driver) => ({
                      label: `${driver.firstName} ${driver.lastName} ${driver.phone ? `(${driver.phone})` : ""}`,
                      value: driver.id,
                      driver: driver,
                      car: driver.car || {
                        plateNumber: driver.plateNumber,
                        model: driver.carModel,
                        brand: driver.carBrand,
                      },
                    }))}
                    onChange={(e) => setDriver(e)}
                  />
                </Form.Group>

                {/* Show car information when driver is selected */}
                {driver?.car && (
                  <div className="mt-2 p-2 border rounded bg-light">
                    <h6 className="mb-2">
                      <i className="fas fa-truck mr-2"></i>
                      Véhicule du chauffeur
                    </h6>
                    <Row>
                      <Col md="6">
                        <small className="text-muted">Modèle:</small>
                        <div>
                          <strong>
                            {driver.car.brand || ""}
                            {driver.car.model || "Non spécifié"}
                          </strong>
                        </div>
                      </Col>
                      <Col md="6">
                        <small className="text-muted">Immatriculation:</small>
                        <div>
                          <strong>
                            {driver.car.registration || "Non spécifié"}
                          </strong>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            </Row>

            {/* Cities Multi-Select */}
            <Row className="mt-3">
              <Col md="12">
                <Form.Group>
                  <label>Villes desservies* </label>
                  <Select
                    isMulti
                    placeholder="Sélectionner une ou plusieurs villes"
                    value={selectedCities}
                    options={cities.map((city) => ({
                      value: city.id,
                      label: city.name,
                      state: city.state,
                      country: city.country,
                    }))}
                    onChange={(selected) => setSelectedCities(selected || [])}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                  <small className="text-muted">
                    Sélectionnez les villes où la marchandise sera livrée
                  </small>
                </Form.Group>
              </Col>
            </Row>

            {/* Date range */}
            <Row className="mt-3">
              <Col md="6">
                <Form.Group>
                  <label>Date de début* </label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    min={date}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <label>Date de fin* </label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    min={startDate || date}
                  />
                </Form.Group>
              </Col>
            </Row>

            <br />

            {/* Items Table */}
            <Row>
              <Col md="12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Button variant="success" onClick={handleAddItem}>
                    <i className="fas fa-plus mr-2"></i>
                    Ajouter un article
                  </Button>
                </div>

                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Produit</th>
                      <th>Quantité</th>
                      <th>Prix unitaire (TND)</th>
                      <th>TVA %</th>
                      <th>Montant TVA</th>
                      <th>Total HT</th>
                      <th>Total TTC</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceItems.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <Select
                            placeholder="Sélectionner un produit"
                            value={getSelectedProductOption(item.productId)}
                            options={products.map((product) => ({
                              value: product.id,
                              label: product.name,
                              price: product.salePrice || product.price || 0,
                              vatRate: product.vat,
                            }))}
                            onChange={(selectedOption) =>
                              handleItemChange(
                                index,
                                "productId",
                                selectedOption.value,
                              )
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            value={item.quantity || 0}
                            type="number"
                            min="1"
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "quantity",
                                parseInt(e.target.value) || 0,
                              )
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            value={item.price || 0}
                            type="number"
                            step="0.01"
                            min="0"
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "price",
                                parseFloat(e.target.value) || 0,
                              )
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            value={item.vatRate}
                            type="number"
                            step="0.01"
                            min="0"
                            readOnly
                          />
                        </td>
                        <td className="text-right">
                          {(item.vatAmount || 0).toFixed(2)}
                        </td>
                        <td className="text-right">
                          {(item.totalHT || 0).toFixed(2)}
                        </td>
                        <td className="text-right">
                          {(item.totalTTC || 0).toFixed(2)}
                        </td>
                        <td>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleRemoveItem(index)}
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* Totals */}
            <Row className="mt-3">
              <Col md="3" className="offset-md-6">
                <Form.Group>
                  <label>Total HT</label>
                  <Form.Control
                    value={(totalHT || 0).toFixed(2)}
                    readOnly
                    className="text-right font-weight-bold"
                  />
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group>
                  <label>Total TVA</label>
                  <Form.Control
                    value={(totalVAT || 0).toFixed(2)}
                    readOnly
                    className="text-right"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="3" className="offset-md-9">
                <Form.Group>
                  <label>Total TTC</label>
                  <Form.Control
                    value={(totalTTC || 0).toFixed(2)}
                    readOnly
                    className="text-right font-weight-bold text-primary"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md="12">
                <Badge bg="info" className="p-2 w-100">
                  <i className="fas fa-truck mr-2"></i>
                  Facture bon sortie - Chauffeur requis, client non requis
                </Badge>
              </Col>
            </Row>
          </Card.Body>

          <Card.Footer>
            <Button
              className="btn-wd btn-outline mr-1 float-left"
              variant="primary"
              onClick={submitForm}
            >
              <i className="fas fa-save mr-2"></i>
              Enregistrer
            </Button>
          </Card.Footer>
        </Card>
      </Form>
    </Container>
  );
}

export default AddShippingNoteInvoice;
